import { render } from "./vcell_compact_icon.vue?vue&type=template&id=d98a8f58"
import script from "./vcell_compact_icon.vue?vue&type=script&lang=js"
export * from "./vcell_compact_icon.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\benny\\Documents\\Programmieren\\Vue\\cellCalculator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__